function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#1A1A1A",
  fillRule: "evenodd",
  d: "M7.937 0l9.313 9.313c.614.614.614 1.604 0 2.208l-5.73 5.729c-.301.302-.708.458-1.103.458-.396 0-.802-.156-1.105-.458l-5.729-5.73c-.614-.603-.614-1.593 0-2.207l5.365-5.365-2.48-2.48L7.939 0zm2.48 5.427l-4.99 4.99h9.98l-4.99-4.99zm9.375 6.552s-2.084 2.26-2.084 3.646c0 1.146.938 2.083 2.084 2.083 1.145 0 2.083-.937 2.083-2.083 0-1.385-2.083-3.646-2.083-3.646zM25 20.833H0V25h25v-4.167z",
  clipRule: "evenodd"
});

var SvgEditorFormatColorFill = function SvgEditorFormatColorFill(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEditorFormatColorFill, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/editor_format_color_fill.183a06e2.svg";
export { ForwardRef as ReactComponent };